/** 护理学 */

/** 对应的标题 */
const categoryMap = {
  Barthel: 'Barthel指数量表',
  Norton: 'Norton分级',
  Bristol: 'Bristol 粪便分类表'
}
/** 对应的描述 */
const categoryDescMap = {
  Barthel: '判断患者生活能力的功能评分',
  Norton: '预测患者压疮风险',
  Bristol: ''
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Nurse.js